import { getPrTemplateVariant } from './templateConstants';

export function mapV1FieldsToV2Data(fields: any, templateId?: string) {
  const additional = fields?.additional_fields || {};
  const variant = getPrTemplateVariant(templateId);
  return {
    title: fields?.title || 'P&R Real Value',
    published_at: fields?.published_at || additional?.dateBadge,
    data_as_of: additional?.data_as_of || additional?.dateBadge,
    investmentStyle: additional?.investmentStyle || '',
    shareClassHistoryNote: additional?.shareClassHistoryNote || '',
    disclaimer: additional?.disclaimer || '',
    historyIsin: additional?.historyIsin,
    historyUntil: additional?.historyUntil,
    // Template id wins: it is the authoritative variant, `additional_fields` may be stale.
    prShareClass: variant?.shareClass ?? additional?.prShareClass,
    prLocale: variant?.locale ?? additional?.prLocale,
    stammdaten: fields?.stammdaten || {},
    preise: fields?.preise || {},
    konditionen: fields?.konditionen || {},
  };
}

export function mergePrPreviewWithV2Data(
  preview: Record<string, any>,
  v2Data: Record<string, any>
): Record<string, any> {
  return {
    ...preview,
    ...v2Data,
    title: v2Data.title ?? preview.title,
    investmentStyle: v2Data.investmentStyle ?? preview.investmentStyle,
    shareClassHistoryNote: v2Data.shareClassHistoryNote ?? preview.shareClassHistoryNote,
    disclaimer: v2Data.disclaimer ?? preview.disclaimer,
    preise: preview.preise,
    konditionen: preview.konditionen,
    stammdaten: preview.stammdaten,
    performanceRows: preview.performanceRows,
    allocations: preview.allocations,
    lineChartData: preview.lineChartData,
    data_as_of: preview.data_as_of ?? v2Data.data_as_of,
    published_at: preview.published_at ?? v2Data.published_at,
    prShareClass: preview.prShareClass ?? v2Data.prShareClass,
    prLocale: preview.prLocale ?? v2Data.prLocale,
  };
}

function deepEqual(a: unknown, b: unknown) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function buildCustomizePayload(v2Data: any, original: any) {
  const payload: Array<{ key: string; value: unknown }> = [];
  const safeOriginal = original || {};
  const origAdditional = safeOriginal.additional_fields || {};

  if ((safeOriginal.title || '') !== (v2Data?.title || '')) {
    payload.push({ key: 'title', value: v2Data?.title || '' });
  }

  const updatedAdditional: Record<string, unknown> = {};
  if (!deepEqual(origAdditional.investmentStyle, v2Data?.investmentStyle)) {
    updatedAdditional.investmentStyle = v2Data?.investmentStyle || '';
  }
  if (!deepEqual(origAdditional.shareClassHistoryNote, v2Data?.shareClassHistoryNote)) {
    updatedAdditional.shareClassHistoryNote = v2Data?.shareClassHistoryNote || '';
  }
  if (!deepEqual(origAdditional.disclaimer, v2Data?.disclaimer)) {
    updatedAdditional.disclaimer = v2Data?.disclaimer || '';
  }
  if (!deepEqual(origAdditional.historyIsin, v2Data?.historyIsin)) {
    updatedAdditional.historyIsin = v2Data?.historyIsin;
  }
  if (!deepEqual(origAdditional.historyUntil, v2Data?.historyUntil)) {
    updatedAdditional.historyUntil = v2Data?.historyUntil;
  }
  if (!deepEqual(origAdditional.data_as_of, v2Data?.data_as_of)) {
    updatedAdditional.data_as_of = v2Data?.data_as_of;
    updatedAdditional.dateBadge = v2Data?.data_as_of;
  }

  if (Object.keys(updatedAdditional).length > 0) {
    payload.push({
      key: 'additional_fields',
      value: { ...origAdditional, ...updatedAdditional },
    });
  }

  if (v2Data?.stammdaten && !deepEqual(safeOriginal.stammdaten, v2Data.stammdaten)) {
    payload.push({ key: 'stammdaten', value: v2Data.stammdaten });
  }
  if (v2Data?.preise && !deepEqual(safeOriginal.preise, v2Data.preise)) {
    payload.push({ key: 'preise', value: v2Data.preise });
  }
  if (v2Data?.konditionen && !deepEqual(safeOriginal.konditionen, v2Data.konditionen)) {
    payload.push({ key: 'konditionen', value: v2Data.konditionen });
  }

  return payload;
}
